var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyBets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.25a.75.75 0 010 1.5H8a.75.75 0 010-1.5h4zM16 7.25a.75.75 0 010 1.5H8a.75.75 0 010-1.5h8z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 3a1 1 0 011 1v16a1 1 0 01-1 1h-.52a1 1 0 01-.705-.291l-.075-.084-1.236-1.545a.1.1 0 00-.143-.015l-1.62 1.35a1 1 0 01-1.275.004l-.072-.064-1.284-1.285a.1.1 0 00-.14 0l-1.284 1.285-.072.064a1 1 0 01-1.199.055l-.076-.059-1.62-1.35a.1.1 0 00-.143.015L6.3 20.625l-.075.084a1 1 0 01-.592.284L5.52 21H5a1 1 0 01-1-1V4a1 1 0 011-1h14zM5.5 19.224l.865-1.081.11-.124a1.6 1.6 0 012.03-.205l.134.1 1.268 1.056.961-.96a1.6 1.6 0 012.142-.11l.122.11.96.96 1.27-1.057.132-.1a1.6 1.6 0 012.14.33l.866 1.08V4.5h-13v14.724z",
    fill: "currentColor"
  })));
}
SvgMyBets.displayName = 'MyBets';
export default SvgMyBets;